import { IAM } from '../apis.js';
const authAPI = IAM('/teams');
export const createNewTeam = (newTeam) => {
    return authAPI('POST', `/`, {
        body: newTeam,
    });
};
export const getAll = async () => authAPI('GET', '/?page=0&pageSize=250');
export const update = (id, tenant) => authAPI('PATCH', `/${id}`, {
    body: tenant,
});
//# sourceMappingURL=teams.js.map